export const setColorScheme = dark => {
  const theme = dark ? 'dark' : 'light'

  document.body.style.overflow = 'hidden'
  document.body.style.colorScheme = theme
  document.body.style.overflow = ''
}
